import { render, staticRenderFns } from "./DeliveryTaskList.vue?vue&type=template&id=413bc496&scoped=true"
import script from "./DeliveryTaskList.vue?vue&type=script&lang=js"
export * from "./DeliveryTaskList.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTaskList.vue?vue&type=style&index=0&id=413bc496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413bc496",
  null
  
)

export default component.exports